import { render, staticRenderFns } from "./line-notify.vue?vue&type=template&id=5d910417&scoped=true&"
import script from "./line-notify.vue?vue&type=script&lang=js&"
export * from "./line-notify.vue?vue&type=script&lang=js&"
import style0 from "./line-notify.vue?vue&type=style&index=0&id=5d910417&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d910417",
  null
  
)

export default component.exports